module.exports = __webpack_public_path__ + "media/images/gallery/constellations/scutum/sct_oc-3fd8c35e79a0f1f7369f619db910bdb5.gif";